<template>
  <b-navbar-dropdown
    @active-change="getBilling"
    :label="`Whatsapp ${maxMsgSend}`"
  >
    <b-navbar-item href="#" class="p-1">
      <div class="modal-card" style="width: 200px">
        <section class="modal-card-body p-1">
          <p class="mb-3">Confirmação por Whatsapp</p>
          <b-field
            v-show="!invoiceUrl"
            label="Comprar Créditos"
            label-position="on-border"
          >
            <currency-input
              v-model="billing.add"
              :currency="null"
              :auto-decimal-mode="true"
              :precision="2"
              :allow-negative="false"
              :value-range="{
                min: 100,
                max: 1000,
              }"
              class="input has-text-right"
              placeholder="Repasse"
            />
          </b-field>
        </section>
        <b-button
          :disabled="billing.add <= 0"
          v-show="!invoiceUrl"
          @click="addBilling()"
          label="Gerar Fatura"
          type="is-info"
          expanded
        />
        <b-button
          v-show="invoiceUrl"
          :href="invoiceUrl"
          tag="a"
          target="_blank"
          expanded
          >Pagar Fatura
        </b-button>
      </div>
    </b-navbar-item>
  </b-navbar-dropdown>
</template>
<script>
export default {
  name: "Billing",
  props: ["maxMsgSend"],
  data() {
    return {
      billing: {
        add: 0,
        current: "",
      },
      invoiceUrl: "",
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  created() {},
  methods: {
    addBilling() {
      this.$http
        .post(`asaas/billing`, {
          value: this.billing.add,
          description: "Max Agenda Crédito Whatsapp",
        })
        .then((response) => (this.invoiceUrl = response.data.invoiceUrl));
    },
    getBilling(active) {
      if (active)
        this.$http
          .get(`doctor/billing`)
          .then((response) => (this.billing.current = response.data));
    },
  },
};
</script>